import { render, staticRenderFns } from "./stockProducto.vue?vue&type=template&id=0ee1fd3e"
import script from "./stockProducto.vue?vue&type=script&lang=js"
export * from "./stockProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports